import React, { FC, ComponentProps } from 'react';
import { faCircleXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Flex,
  TextInputV2 as TextInput,
  BoxV2 as Box,
  SxProps,
} from 'portal-commons';

interface IRemovableTextInput extends ComponentProps<typeof TextInput> {
  removable?: boolean;
  onRemoveClick?: () => void;
  sx?: SxProps;
}

const RemovableTextInput: FC<IRemovableTextInput> = ({
  removable = true,
  onRemoveClick,
  children,
  sx,
  ...inputProps
}) => {
  return (
    <Flex
      sx={{ alignItems: 'flex-start', gap: '8px', position: 'relative', ...sx }}
    >
      <Box
        sx={{
          width: '100%',
          '& input.MuiInputBase-input': {
            paddingRight: '40px !important',
          },
        }}
      >
        <TextInput
          {...inputProps}
          endAdornment={
            removable && (
              <Flex
                role="button"
                sx={{
                  width: '24px',
                  height: '24px',
                  fontSize: '16px',
                  color: '#666E71',
                  cursor: 'pointer',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
                onClick={() => onRemoveClick?.()}
              >
                <FontAwesomeIcon icon={faCircleXmark} />
              </Flex>
            )
          }
        />
      </Box>
      {children}
    </Flex>
  );
};

export default RemovableTextInput;
